export default "__VITE_ASSET__26d0ee61__"